module.exports = __webpack_public_path__ + "static/media/sprite-side-effects.dceb74d4.png";